// extracted by mini-css-extract-plugin
export default {"header":"_2n9Yq","wrapper":"_2jsMl","headerWrapper":"_1P9vF","sectionInstall":"_3_mkT","programs":"_3yYHl","programsText":"_2k-RQ","installText":"_3ZhNz","install":"geiOF"};